import { FC } from "react";
import { IconProps } from "./types";

export const LineArrow: FC<IconProps> = ({
  fill = "currentColor",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    {...props}
  >
    <path
      d="M9.39935 5.39935C9.7313 5.0674 10.2686 5.0674 10.6005 5.39935C10.9325 5.7313 10.9325 6.26858 10.6005 6.60052L6.05072 11.1503H18.9999C19.4694 11.1503 19.8495 11.5305 19.8495 11.9999C19.8495 12.4694 19.4694 12.8495 18.9999 12.8495H6.05072L10.6005 17.3994C10.9325 17.7313 10.9325 18.2686 10.6005 18.6005C10.2686 18.9325 9.7313 18.9325 9.39935 18.6005L3.39935 12.6005C3.0674 12.2686 3.0674 11.7313 3.39935 11.3993L9.39935 5.39935Z"
      fill={fill}
    />
  </svg>
);
